import React, { useCallback, useEffect, useState } from "react";
import Router from "next/router";
import Container from "../Container";
import useTranslation, { useRoutes } from "../../helpers/translationTexts/useTranslation";
import { Loader, LoaderContainer } from "./LoginFinish.components";
import { facebookLogin, googleLogin } from "../../api/authApis";
import { useSession } from "../../context/SessionProvider";
import syncManager from "../../api/SyncManager";
import { LocalStorage } from "../../utils/LocalStorage";
import { AuthInfoModal } from "../modal";

type Props = {
  socialType: string;
  accessToken: string;
  language: string;
};

const LoginFinish: React.FC<Props> = ({ socialType, accessToken, language }) => {
  const [isOpenAuthInfoModal, setIsOpenAuthInfoModal] = useState(false);
  const registrationPath = useRoutes(language).Registration;
  const rootPath = useRoutes().Root;
  const savedPath = LocalStorage.getPathRedirectAfterLogin() || rootPath;
  const { setUserData } = useSession();

  const title = useTranslation("authInfoModalTitleFailed");
  const description = useTranslation("authorizationFailedMessage");
  const btnName = useTranslation("ok");

  const doLogin = useCallback(async () => {
    const data = socialType === "facebook" ? await facebookLogin(accessToken) : await googleLogin(accessToken);

    if (data.error) {
      setIsOpenAuthInfoModal(true);
      return;
    }

    syncManager.updateTokens(data);

    const userData = data.user as UserData;

    setUserData(userData);

    if (userData.nickname && userData.countryCode) {
      syncManager.sendOfflineProgress();
      LocalStorage.removePathRedirectAfterLogin();
      Router.replace(savedPath);
    } else {
      Router.push(registrationPath);
    }
  }, [accessToken, registrationPath, savedPath, setUserData, socialType]);

  useEffect(() => {
    doLogin();
  }, []);

  return (
    <>
      <Container>
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      </Container>
      {isOpenAuthInfoModal && (
        <AuthInfoModal
          isOpen={isOpenAuthInfoModal}
          title={title}
          description={description}
          onCloseClicked={() => {
            setIsOpenAuthInfoModal(false);
            Router.push(savedPath);
          }}
          btnNameCancel={btnName}
        />
      )}
    </>
  );
};

export default LoginFinish;
